
import { useCallback } from 'react';
import { usePermissions, UserPermission, WriteOn, ReadOn } from 'modules/permissions';
import { ConditionalRender } from 'components/layout/ConditionalRender';
import {
    StyledSubHeader,    
    StyledSubHeaderGroup,
    StyledSubHeaderSection,
    StyledSubHeaderTabContainer
} from 'shared/styled/SubHeader.styled';
import SubHeaderTab from 'components/SubHeaderTab';
import { FontIcon } from '@fluentui/react';
import { SheqManagerDisplayEnum } from '../../enums/sheq-manager-display.enum';
import { useTranslation } from 'react-i18next';

interface SheqManagerSubHeaderProps {
    displayMode: SheqManagerDisplayEnum;
    formHasErrors: boolean;
    goToOverview: () => void;
    goToAuditLog: () => void;
}

const SheqManagerSubHeader = ({    
    displayMode,
    formHasErrors,
    goToOverview,
    goToAuditLog
}: SheqManagerSubHeaderProps) =>{
    
    
    const { hasPermission } = usePermissions();    
    const { t } = useTranslation();
    return (
        <StyledSubHeader>
            <StyledSubHeaderSection style={{ flex: '2 1 auto' }}>
                <StyledSubHeaderGroup style={{ justifyContent: 'flex-end' }}>
                    <StyledSubHeaderTabContainer>
                        <SubHeaderTab
                            onClick={goToOverview}
                            isActive={displayMode === SheqManagerDisplayEnum.Overview}
                            display={t('SheqManager.Overview')}
                            highlightErrors={formHasErrors}
                        />                        
                        <ConditionalRender condition={hasPermission(ReadOn(UserPermission.Audit))}>
                            <SubHeaderTab
                                onClick={goToAuditLog}
                                isActive={displayMode === SheqManagerDisplayEnum.Audit}
                                display={<FontIcon iconName='History' />}
                                title={t('SheqManager.AuditLog')}
                            />
                        </ConditionalRender>
                    </StyledSubHeaderTabContainer>
                </StyledSubHeaderGroup>               
            </StyledSubHeaderSection>
        </StyledSubHeader>
    )
};

export default SheqManagerSubHeader;